import { siteFooter } from '../content';

export function SiteFooter() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <p className="footer__credit">
          {siteFooter.credit.map((segment, i) =>
            typeof segment === 'string' ? (
              segment
            ) : (
              <a key={i} href={segment.url} target="_blank" rel="noreferrer noopener">
                {segment.text}
              </a>
            ),
          )}
        </p>
        <ul className="footer__links">
          {siteFooter.links.map((link) => (
            <li key={link.href}>
              {link.external ? (
                <a href={link.href} target="_blank" rel="noreferrer noopener">
                  {link.label}
                </a>
              ) : (
                <a href={link.href}>{link.label}</a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
